exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unity-player_unity-wrapper_1W9v6 {\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.unity-player_unity-wrapper-hidden_2PcFa {\n    visibility: hidden;\n}\n\n.unity-player_unity-canvas_28UJ_ {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    width: 100%;\n    height: 100%;\n    z-index: 8;\n}\n", ""]);

// exports
exports.locals = {
	"unity-wrapper": "unity-player_unity-wrapper_1W9v6",
	"unityWrapper": "unity-player_unity-wrapper_1W9v6",
	"unity-wrapper-hidden": "unity-player_unity-wrapper-hidden_2PcFa",
	"unityWrapperHidden": "unity-player_unity-wrapper-hidden_2PcFa",
	"unity-canvas": "unity-player_unity-canvas_28UJ_",
	"unityCanvas": "unity-player_unity-canvas_28UJ_"
};